export const environment = {
  production: true,
  buildId: '3246310034921031',
  configFile: 'config.json',
};
